import React from 'react';
import './ChatCard.scss';
import Image from '../../../assets/images/avatar.png';
import {useCurrentChatStore} from "../../../store";
import {timeAgo} from "../../../services/date_service";

const ChatCard = ({data}: any) => {

    const {updateCurrentChat, currentChat} = useCurrentChatStore()
    const isActive = currentChat?.bot_id === data?.bot_id;
    const lastMessage = data?.last_message;
    const preview = lastMessage
        ? `${lastMessage.message_sender === 'user' ? 'You: ' : ''}${lastMessage.message_type === 'voice_message' ? 'Voice message' : lastMessage.message}`
        : 'No messages yet';

    return (
        <button type="button" onClick={() => updateCurrentChat(data)}
                className={`ChatCard ${isActive ? 'activeChat' : ''}`}>
            <img src={data.avatar || Image} alt=""/>
            <div className="ChatCard__name">
                <div className="ChatCard__row">
                    <h3 className="ChatCard__title">{data.chat_name}</h3>
                    {lastMessage?.date && <span className="ChatCard__time">{timeAgo(lastMessage.date)}</span>}
                </div>
                <span className={`ChatCard__last-message ${lastMessage ? '' : 'ChatCard__last-message--empty'}`}>
                    {preview}
                </span>
                <span className="ChatCard__last-contact">{data.person_to_copy}</span>
            </div>
        </button>
    );
};

export default ChatCard;
